/**
 * GT THRONE — Interactions JS
 * User-triggered interactions for homepage sections
 * Loaded on every page via theme.liquid (deferred)
 *
 * Behaviors:
 * 1. Stagger Testimonials — card fan navigation
 * 2. Compatibility hover preview
 * 3. FAQ accordion
 * 4. Image lightbox
 * 5. Social card sound toggle
 * 6. FX Scroll mobile accordion (<=989px)
 */

(function () {
  'use strict';

  /* ---- 1. STAGGER TESTIMONIALS ---- */
  (function initStaggerTestimonials() {
    document.addEventListener('DOMContentLoaded', function () {
      var stage = document.getElementById('staggerStage');
      if (!stage) return;

      var testimonials = [
        { quote: 'The GT Throne changed how I game. I feel every explosion, every crash — it\'s unreal.', by: 'Alex, Competitive FPS Player' },
        { quote: 'Plug and play, no drivers, no hassle. Best upgrade I\'ve made to my setup in years.', by: 'Dan, PC Enthusiast' },
        { quote: 'I was skeptical, but 10 minutes in and I was completely sold. You FEEL the game.', by: 'Stephanie, Console Gamer' },
        { quote: 'The heating feature is a game changer for long sessions. Comfort and immersion in one.', by: 'Marie, Streamer' },
        { quote: 'If I could give 11 stars, I\'d give 12. This thing is insane.', by: 'Andre, Racing Sim Fan' },
        { quote: 'My viewers can literally see me react to the haptics on stream. It\'s content gold.', by: 'Jeremy, Twitch Streamer' },
        { quote: 'Took some convincing from my buddy, but now I can\'t game without it.', by: 'Pam, Casual Gamer' },
        { quote: 'The bass response is incredible. Movies, music, games — everything hits different.', by: 'Daniel, Audio Nerd' },
        { quote: 'It\'s just the best gaming accessory. Period.', by: 'Fernando, Esports Coach' },
        { quote: 'I switched from a full sim rig vibration setup to this. Easier, cheaper, better.', by: 'Andy, Sim Racer' },
        { quote: 'I\'ve been searching for something like this for years. Finally found it.', by: 'Pete, RPG Enthusiast' },
        { quote: 'Set it up in under a minute. My whole squad ordered one the same night.', by: 'Marina, Squad Leader' }
      ];

      var staggerIndex = 0;
      var isMobile = window.innerWidth <= 768;
      var cardSize = isMobile ? 280 : 365;

      /* Build cards */
      testimonials.forEach(function (t, i) {
        var card = document.createElement('div');
        card.className = 'stagger-card';
        card.innerHTML =
          '<div class="stagger-card__quote">"' + t.quote + '"</div>' +
          '<div class="stagger-card__author">— ' + t.by + '</div>';
        stage.appendChild(card);
      });

      var cards = stage.querySelectorAll('.stagger-card');

      function positionCards() {
        var visibleCount = Math.min(cards.length, 7);
        var center = Math.floor(visibleCount / 2);

        cards.forEach(function (card, i) {
          var position = i - staggerIndex;
          if (position < -center) position += cards.length;
          if (position > center) position -= cards.length;

          var isCenter = position === 0;
          card.classList.toggle('is-center', isCenter);

          if (isMobile) return;

          var offsetX = (cardSize / 1.5) * position;
          var offsetY = isCenter ? -65 : (position % 2 ? 15 : -15);
          var rotate = isCenter ? 0 : (position % 2 ? 2.5 : -2.5);
          var scale = isCenter ? 1 : 0.85;
          var zIndex = isCenter ? 10 : 5 - Math.abs(position);
          var opacity = Math.abs(position) <= center ? 1 : 0;

          card.style.transform =
            'translate(-50%,-50%) translateX(' + offsetX + 'px) translateY(' + offsetY + 'px) rotate(' + rotate + 'deg) scale(' + scale + ')';
          card.style.zIndex = zIndex;
          card.style.opacity = opacity;
        });
      }

      positionCards();

      var prevBtn = document.getElementById('staggerPrev');
      var nextBtn = document.getElementById('staggerNext');

      if (prevBtn) {
        prevBtn.addEventListener('click', function () {
          staggerIndex = (staggerIndex - 1 + cards.length) % cards.length;
          positionCards();
        });
      }
      if (nextBtn) {
        nextBtn.addEventListener('click', function () {
          staggerIndex = (staggerIndex + 1) % cards.length;
          positionCards();
        });
      }

      /* Mobile: update active (yellow) card based on horizontal scroll */
      if (isMobile) {
        var scrollRaf = null;
        stage.addEventListener('scroll', function () {
          if (scrollRaf) return;
          scrollRaf = requestAnimationFrame(function () {
            scrollRaf = null;
            var stageLeft = stage.getBoundingClientRect().left;
            var activeIdx = 0;
            var minDist = Infinity;
            cards.forEach(function (card, i) {
              var dist = Math.abs(card.getBoundingClientRect().left - stageLeft);
              if (dist < minDist) {
                minDist = dist;
                activeIdx = i;
              }
            });
            if (activeIdx !== staggerIndex) {
              staggerIndex = activeIdx;
              cards.forEach(function (card, i) {
                card.classList.toggle('is-center', i === staggerIndex);
              });
            }
          });
        }, { passive: true });
      }
    });
  })();

  /* ---- 2. COMPATIBILITY HOVER PREVIEW ---- */
  (function initCompatPreview() {
    document.addEventListener('DOMContentLoaded', function () {
      var preview = document.getElementById('compatPreview');
      if (!preview) return;

      var compatData = {
        ps5: { title: 'PlayStation 5', sub: 'Full haptic sync via 3.5mm audio' },
        xbox: { title: 'Xbox Series X', sub: 'Plug & play — no adapter needed' },
        pc: { title: 'Gaming PC', sub: 'Works with any audio output' },
        racing: { title: 'Racing Simulator', sub: 'Feel every corner and collision' },
        flight: { title: 'Flight Sim Seat', sub: 'Turbulence and engine feedback' },
        vr: { title: 'Virtual Reality', sub: 'Total immersion across any headset' },
        chair: { title: 'Any Chair', sub: 'Universal straps fit any seat' }
      };

      var previewTitle = document.getElementById('compatPreviewTitle');
      var previewSub = document.getElementById('compatPreviewSub');

      document.querySelectorAll('.compat-link[data-compat]').forEach(function (link) {
        link.addEventListener('mouseenter', function (e) {
          var key = this.getAttribute('data-compat');
          var data = compatData[key];
          if (!data) return;

          if (previewTitle) previewTitle.textContent = data.title;
          if (previewSub) previewSub.textContent = data.sub;

          preview.style.left = e.clientX + 'px';
          preview.style.top = (e.clientY - 80) + 'px';
          preview.classList.add('visible');
        });

        link.addEventListener('mouseleave', function () {
          preview.classList.remove('visible');
        });

        link.addEventListener('mousemove', function (e) {
          preview.style.left = e.clientX + 'px';
          preview.style.top = (e.clientY - 80) + 'px';
        });
      });
    });
  })();

  /* ---- 3. FAQ ACCORDION ---- */
  (function initFaqAccordion() {
    document.addEventListener('DOMContentLoaded', function () {
      var faqItems = document.querySelectorAll('.faq-item');
      if (!faqItems.length) return;

      faqItems.forEach(function (item) {
        var question = item.querySelector('.faq-question');
        if (!question) return;

        question.addEventListener('click', function () {
          var isActive = item.classList.contains('active');

          /* Close all others */
          faqItems.forEach(function (other) {
            other.classList.remove('active');
            var otherBtn = other.querySelector('.faq-question');
            if (otherBtn) otherBtn.setAttribute('aria-expanded', 'false');
          });

          /* Toggle clicked */
          if (!isActive) {
            item.classList.add('active');
            question.setAttribute('aria-expanded', 'true');
          }
        });
      });
    });
  })();

  /* ---- 4. IMAGE LIGHTBOX ---- */
  (function initLightbox() {
    document.addEventListener('DOMContentLoaded', function () {
      var lightbox = document.getElementById('gtLightbox');
      if (!lightbox) return;

      var lightboxImg = lightbox.querySelector('.lightbox-img');
      var closeBtn = lightbox.querySelector('.lightbox-close');

      document.querySelectorAll('.zoom-parallax__image img').forEach(function (img) {
        img.addEventListener('click', function () {
          if (lightboxImg) lightboxImg.src = this.src;
          lightbox.classList.add('active');
          document.body.style.overflow = 'hidden';
        });
      });

      function closeLightbox() {
        lightbox.classList.remove('active');
        document.body.style.overflow = '';
      }

      if (closeBtn) closeBtn.addEventListener('click', closeLightbox);
      lightbox.addEventListener('click', function (e) {
        if (e.target === lightbox) closeLightbox();
      });
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') closeLightbox();
      });
    });
  })();

  /* ---- 5. SOCIAL CARD SOUND TOGGLE ---- */
  (function initSocialCardSound() {
    document.addEventListener('DOMContentLoaded', function () {
      var soundBtns = document.querySelectorAll('.social-card__sound');
      if (!soundBtns.length) return;

      soundBtns.forEach(function (btn) {
        btn.addEventListener('click', function (e) {
          e.stopPropagation();
          var card = this.closest('.social-card');
          var video = card ? card.querySelector('video') : null;
          if (!video) return;

          var isUnmuted = this.classList.contains('is-unmuted');

          /* Mute all others */
          document.querySelectorAll('.social-card video').forEach(function (v) {
            v.muted = true;
          });
          document.querySelectorAll('.social-card__sound').forEach(function (b) {
            b.classList.remove('is-unmuted');
            b.innerHTML = '<i class="ph ph-speaker-slash" aria-hidden="true"></i>';
          });

          /* Toggle clicked */
          if (!isUnmuted) {
            video.muted = false;
            this.classList.add('is-unmuted');
            this.innerHTML = '<i class="ph ph-speaker-high" aria-hidden="true"></i>';
          }
        });
      });
    });
  })();

  /* ---- 6. FX SCROLL MOBILE ACCORDION ---- */
  (function initFxScrollAccordion() {
    document.addEventListener('DOMContentLoaded', function () {
      var section = document.getElementById('fx-scroll');
      if (!section) return;

      var titles = section.querySelectorAll('.fx-title');
      if (!titles.length) return;

      var mq = window.matchMedia('(max-width: 989px)');

      titles.forEach(function (title) {
        var toggle = title.querySelector('.fx-title-toggle');
        if (!toggle) return;

        toggle.addEventListener('click', function () {
          /* Accordion only active in the stacked tablet/mobile layout */
          if (!mq.matches) return;

          var isOpen = title.classList.contains('fx-title--open');

          /* Close all others */
          titles.forEach(function (other) {
            other.classList.remove('fx-title--open');
            var otherToggle = other.querySelector('.fx-title-toggle');
            if (otherToggle) otherToggle.setAttribute('aria-expanded', 'false');
          });

          /* Toggle clicked */
          if (!isOpen) {
            title.classList.add('fx-title--open');
            toggle.setAttribute('aria-expanded', 'true');
          }
        });
      });

      /* Reset open state when switching back to desktop layout */
      mq.addEventListener('change', function (e) {
        if (!e.matches) {
          titles.forEach(function (title) {
            title.classList.remove('fx-title--open');
            var toggle = title.querySelector('.fx-title-toggle');
            if (toggle) toggle.setAttribute('aria-expanded', 'false');
          });
        }
      });
    });
  })();
})();
